export const getCarPriceInPageCTA = {
    event: "get_car_price_in_page_cta",
    eventCategory: "homepage_dweb",
    eventAction: "get_car_price_in_page_clicked"
};

export const sellCarNowInPageCTA = {
    event: "sell_car_now_in_page_cta",
    eventCategory: "homepage_dweb",
    eventAction: "sell_car_now_in_page_clicked"
};

export const popularCityTextClick = {
    event: "popular_city_text_click",
    eventCategory: "homepage_dweb",
    eventAction: "popular_city_clicked"
};

export const getCarPriceBottom =  {
    eventCategory: "homepage_dweb",
    event: "get_car_price_bottom",
    eventAction: "Get car price bottom CTA"
};
